import { ArrowUpRight } from "lucide-react";
import { BUY_URL } from "@/data/products";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="relative bg-black border-t border-white/10">
      {/* CTA band */}
      <div className="mx-auto max-w-[1600px] px-5 sm:px-8 py-16 sm:py-24">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <h2 className="font-display uppercase leading-[0.82] tracking-tight text-white text-6xl sm:text-8xl lg:text-9xl">
            Ready to
            <br />
            <span className="text-ebc-red">stop hard?</span>
          </h2>
          <a
            href={BUY_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-buy-now"
            className="group inline-flex items-center gap-4 bg-ebc-red hover:bg-ebc-redhover text-white font-mono text-sm uppercase tracking-[0.15em] px-8 py-5 transition-colors duration-300 self-start"
          >
            Buy Now
            <ArrowUpRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1600px] px-5 sm:px-8 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-baseline gap-2">
            <span className="font-display text-2xl text-white">EBC</span>
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-ebc-red">Brakes</span>
          </div>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">
            World Leading Brake Specialists — Showcase Concept
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-600">
            © 2026 EBC Brakes
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1600px] px-5 sm:px-8 py-5">
          <p
            data-testid="importer-note"
            className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.2em] text-neutral-500 leading-relaxed text-center"
          >
            Website is managed by Importer of EBC Brakes in India —{" "}
            <span className="text-neutral-300">Plusgrow Merchantry Pvt Ltd</span>, T31A MIDC, Hingna Rd, Nagpur 16
          </p>
        </div>
      </div>
    </footer>
  );
};
